import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { performanceRoutes } from 'routes';
import DefaultView from 'components/ui/DefaultView';
import AppRoute from 'components/AppRoute';
import './style.css';

const renderRedirect = () => <Redirect to="/performance/overview" />;

const RedirectTo404Page = () => <Redirect to="/404" />;

const EmailPerformance = () => (
  <DefaultView>
    <Switch>
      <AppRoute
        component={renderRedirect} // eslint-disable-line react/jsx-no-bind
        exact
        path="/performance"
        permission="performance.overview.view"
      />
      {performanceRoutes.map(({ component, path, permission }) => (
        <AppRoute
          component={component}
          key={path}
          path={path}
          permission={permission}
        />
      ))}
      <Route component={RedirectTo404Page} />
    </Switch>
  </DefaultView>
);

export default EmailPerformance;
